<div style="position: relative;">
    <mat-icon class="close-icon" (click)="closeModal()">close</mat-icon>
    <img [src]="sanitizeImageUrl(modalData)" alt="" class="preview">
</div>

